import { uploadToCos } from '@tencent/calendar-framework-wemeet-upload';

/** 将blob文件上传到临时图片cos桶 */
export const uploadFile = (blobUrl: string, name: string) =>
  fetch(blobUrl)
    .then((r) => r.blob())
    .then((blob) => {
      const file = new File([blob], name, { type: 'image/jpg' });
      return uploadToCos(file, undefined, undefined, undefined, 'activity_temporary');
    });
